import { render, staticRenderFns } from "./ProfileSuggests.vue?vue&type=template&id=6df75fc6&"
import script from "./ProfileSuggests.vue?vue&type=script&lang=js&"
export * from "./ProfileSuggests.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSuggests.vue?vue&type=style&index=0&id=6df75fc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports